import script from "./TextEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextEditor.vue?vue&type=script&lang=ts&setup=true"

import "./TextEditor.vue?vue&type=style&index=0&id=c37536be&lang=css"

const __exports__ = script;

export default __exports__